import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import useGetColors from 'shared/hooks/useGetColors';
import TemplateForm from './TemplateForm';
import { ReactNode, useEffect } from "react";
import { useForm, FormProvider } from 'react-hook-form';
import { CreateTemplateFormT, createTemplateResolver, getCreateChannelTemplateValues } from 'shared/form-values/channels';
import { TemplateT } from "shared/api/types/channels";
import { useTranslation } from 'react-i18next'

interface Props {
  title: string;
  isOpen: boolean;
  onClose: VoidFunction;
  template: TemplateT;
  onSubmit: (data: CreateTemplateFormT) => void;
  buttonText: string;
  isLoading?: boolean;

  formFilesPreviewSlot?: ReactNode;
}

const TemplateModal = ({ title, isOpen, onClose, onSubmit, template, buttonText, isLoading, formFilesPreviewSlot }: Props) => {
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();
  const { t } = useTranslation();

  const methods = useForm<CreateTemplateFormT>({
    defaultValues: getCreateChannelTemplateValues(template),
    resolver: createTemplateResolver,
    mode: "onChange"
  });
  const { formState: { isValid }, trigger, getValues } = methods;

  useEffect(() => {
    trigger();
  }, []);

  useEffect(() => {
    methods.reset(getCreateChannelTemplateValues(template));
  }, [template, isOpen])



  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(() => onSubmit(getValues()))}>
              <TemplateForm filesPreviewSlot={formFilesPreviewSlot} />
              <Flex mt="7" justifyContent="end">
                <Button
                  color={gray800}
                  bgColor={gray100}
                  borderRadius="8px"
                  onClick={onClose}
                  w="100px"
                >
                  {t('buttons.cancel')}
                </Button>
                <Button
                  color={white}
                  bgColor={gray100}
                  borderRadius="8px"
                  backgroundColor={brand500}
                  _hover={{
                    background: brand400,
                  }}
                  ml="20px"
                  w="100px"
                  type="submit"
                  isDisabled={!isValid || isLoading}
                >
                  {buttonText}
                </Button>
              </Flex>
            </form>
          </FormProvider>
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};

export default TemplateModal;
